(() => {
  if (!window.tcgCategoryNavBound) {
    window.tcgCategoryNavBound = true;
    const roots = () => [...document.querySelectorAll('.tcg-premium [data-tcg-root]')];
    const closeBranch = detail => {
      detail.querySelectorAll('details[open]').forEach(child => { child.open = false; });
      detail.open = false;
    };
    const closeMenus = except => roots().forEach(detail => { if (detail !== except) closeBranch(detail); });
    const hoverPointer = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
    const placePanel = detail => {
      const summary = detail.querySelector(':scope > summary');
      const panel = detail.querySelector(':scope > .tcg-nav__panel, :scope > .tcg-nav__flyout');
      if (!panel || !detail.open) return;
      const row = summary.getBoundingClientRect();
      const width = panel.getBoundingClientRect().width;
      if (detail.matches('[data-tcg-root]')) {
        const left = Math.max(12, Math.min(row.left, window.innerWidth - width - 12));
        panel.style.left = `${left - detail.getBoundingClientRect().left}px`;
        panel.style.maxHeight = `${Math.max(100, window.innerHeight - panel.getBoundingClientRect().top - 16)}px`;
      } else {
        const parent = detail.closest('.tcg-nav__panel').getBoundingClientRect();
        const left = parent.right + width + 4 <= window.innerWidth - 12 ? parent.right + 4 : parent.left - width - 4;
        const top = Math.max(12, Math.min(row.top - 8, window.innerHeight - panel.getBoundingClientRect().height - 12));
        panel.style.setProperty('--tcg-flyout-left', `${Math.max(12, left)}px`);
        panel.style.setProperty('--tcg-flyout-top', `${top}px`);
        const rendered = panel.getBoundingClientRect();
        panel.style.setProperty('--tcg-flyout-left', `${2 * Math.max(12, left) - rendered.left}px`);
        panel.style.setProperty('--tcg-flyout-top', `${2 * top - rendered.top}px`);
      }
    };
    document.querySelectorAll('.tcg-premium details').forEach(detail => {
      let closeTimer;
      detail.querySelector(':scope > summary').addEventListener('click', event => {
        if (hoverPointer.matches && event.detail > 0 && detail.open) event.preventDefault();
      });
      detail.addEventListener('pointerenter', event => {
        if (!hoverPointer.matches || event.pointerType === 'touch') return;
        clearTimeout(closeTimer);
        if (detail.matches('[data-tcg-root]')) closeMenus(detail);
        else detail.closest('.tcg-flyout-list').querySelectorAll('.tcg-nav__branch').forEach(other => { if (other !== detail) closeBranch(other); });
        detail.open = true;
        placePanel(detail);
      });
      detail.addEventListener('pointerleave', event => {
        if (!hoverPointer.matches || event.pointerType === 'touch') return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => closeBranch(detail), 200);
      });
      detail.addEventListener('toggle', () => {
        const summary = detail.querySelector(':scope > summary');
        summary.setAttribute('aria-expanded', String(detail.open));
        if (detail.open) {
          if (detail.matches('[data-tcg-root]')) closeMenus(detail);
          else detail.closest('.tcg-flyout-list').querySelectorAll('.tcg-nav__branch').forEach(other => { if (other !== detail) closeBranch(other); });
          placePanel(detail);
        } else detail.querySelectorAll('details[open]').forEach(child => { child.open = false; });
      });
      const panel = detail.querySelector(':scope > .tcg-nav__panel');
      if (panel) panel.addEventListener('scroll', () => panel.querySelectorAll('.tcg-nav__branch[open]').forEach(placePanel), { passive: true });
    });
    document.addEventListener('click', event => { if (!event.target.closest('.tcg-nav')) closeMenus(); });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const nav = event.target.closest('.tcg-nav');
      if (!nav) return;
      const detail = event.target.closest('details[open]') || nav.querySelector('[data-tcg-root][open]');
      if (detail) { event.preventDefault(); closeBranch(detail); detail.querySelector(':scope > summary').focus(); }
    });
    document.addEventListener('focusin', event => { if (!event.target.closest('.tcg-nav')) closeMenus(); });
    window.addEventListener('resize', () => {
      document.querySelectorAll('.tcg-premium details[open]').forEach(placePanel);
    }, { passive: true });
  }

  const drawer = document.querySelector('.tcg-mobile');
  const hamburger = drawer && document.querySelector('.m-hamburger-box');
  if (hamburger && !hamburger.dataset.tcgAccessible) {
    hamburger.dataset.tcgAccessible = 'true';
    hamburger.setAttribute('role', 'button');
    hamburger.setAttribute('tabindex', '0');
    hamburger.setAttribute('aria-controls', 'm-menu-drawer');
    const updateDrawerState = () => {
      const open = drawer.classList.contains('open');
      hamburger.setAttribute('aria-expanded', String(open));
      hamburger.setAttribute('aria-label', open ? drawer.dataset.closeLabel : drawer.dataset.openLabel);
      drawer.querySelectorAll('[data-toggle-submenu]').forEach(button => {
        const submenu = button.closest('li').querySelector('.m-megamenu-mobile');
        button.setAttribute('aria-expanded', String(!!submenu && submenu.classList.contains('open')));
      });
    };
    updateDrawerState();
    new MutationObserver(updateDrawerState).observe(drawer, { attributes: true, attributeFilter: ['class'], subtree: true });
    hamburger.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); hamburger.click(); }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && drawer.classList.contains('open')) { hamburger.click(); hamburger.focus(); }
    });
  }

  document.querySelectorAll('.tcg-pmobile').forEach(nav => {
    nav.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
      detail.querySelector(':scope > summary').setAttribute('aria-expanded', String(detail.open));
      if (detail.open) {
        detail.parentElement.parentElement.querySelectorAll(':scope > li > details[open]').forEach(other => {
          if (other !== detail) other.open = false;
        });
      } else detail.querySelectorAll('details[open]').forEach(child => { child.open = false; });
    }));
    nav.querySelector('[data-tcg-mobile-close]')?.addEventListener('click', () => {
      if (drawer?.classList.contains('open')) { hamburger.click(); hamburger.focus(); }
    });
  });

  if (customElements.get('tcg-category')) return;
  class TcgCategory extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.initialize();
    }

    async initialize() {
      this.grid = this.querySelector('[data-category-grid]');
      this.form = this.querySelector('[data-category-filters]');
      this.sort = this.querySelector('[data-category-sort]');
      this.pageSize = Number(this.dataset.pageSize);
      this.page = 1;
      this.pool = [...this.grid.querySelectorAll('[data-category-item]')];
      try {
        // Fetch subsequent Shopify pages before sorting or filtering the whole collection.
        // The current catalog fits in the first 250-product Liquid page.
        const pages = Number(this.grid.dataset.totalPages);
        const current = Number(this.grid.dataset.currentPage);
        const seen = new Set(this.pool.map((node) => node.dataset.id));
        for (let page = 1; page <= pages; page += 1) {
          if (page === current) continue;
          const url = new URL(location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('page', page);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Category page unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fetchedGrid = html.querySelector('[data-category-grid]');
          if (!fetchedGrid) throw new Error('Category grid unavailable');
          fetchedGrid.querySelectorAll('[data-category-item]').forEach((node) => {
            if (!seen.has(node.dataset.id)) {
              seen.add(node.dataset.id);
              this.grid.append(node);
              this.pool.push(node);
            }
          });
        }
        this.items = this.pool.map((node) => ({
          node, title: node.dataset.title, price: Number(node.dataset.price),
          available: node.dataset.available === 'true', live: node.dataset.live === 'true',
          tags: JSON.parse(node.dataset.tags)
        }));
        this.collator = new Intl.Collator(document.documentElement.lang || 'nl', { numeric: true, sensitivity: 'base' });
        this.buildSets();
        this.populateCounts();
        this.readUrl();
        this.querySelector('[data-server-pagination]').hidden = true;
        this.querySelector('[data-category-toolbar]').hidden = false;
        this.querySelector('.tcg-category__filters').hidden = false;
        if (this.form.elements.namedItem('set')) this.querySelector('[data-set-rail]').hidden = false;
        this.classList.add('is-ready');
        this.bind();
        this.apply();
      } catch (error) {
        // Retain Shopify's rendered product list and pagination if loading fails.
        this.querySelector('[data-category-error]').hidden = false;
        console.error('TCG category loading failed:', error);
      }
    }

    buildSets() {
      const labels = Object.assign({}, ...this.pool.map((node) => JSON.parse(node.dataset.setLabels)));
      const tags = Object.keys(labels).sort((a, b) => this.collator.compare(labels[a], labels[b]));
      const options = this.querySelector('[data-set-options]');
      const rail = this.querySelector('[data-set-rail] .tcg-category__pills');
      tags.forEach((tag, index) => {
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'checkbox'; input.name = 'set'; input.value = tag;
        const name = document.createElement('span'); name.textContent = labels[tag];
        const count = document.createElement('span'); count.className = 'tcg-count'; count.dataset.setCount = tag;
        label.append(input, name, count); options.append(label);
        if (index < 6) {
          const button = document.createElement('button');
          button.type = 'button'; button.dataset.setChip = tag;
          button.setAttribute('aria-pressed', 'false'); button.textContent = labels[tag];
          rail.insertBefore(button, rail.lastElementChild);
        }
      });
      this.querySelector('[data-set-fieldset]').hidden = tags.length === 0;
    }

    populateCounts() {
      this.querySelectorAll('[data-set-count]').forEach((element) => {
        element.textContent = this.items.filter((item) => item.tags.includes(element.dataset.setCount)).length;
      });
      this.querySelectorAll('[data-stock-count]').forEach((element) => {
        element.textContent = this.items.filter((item) => String(item.available) === element.dataset.stockCount).length;
      });
    }

    readUrl() {
      const params = new URL(location.href).searchParams;
      this.form.reset();
      this.form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.checked = params.getAll(`tcg_${input.name}`).includes(input.value);
      });
      ['min', 'max'].forEach((name) => {
        const value = params.get(`tcg_${name}`);
        this.form.elements.namedItem(name).value = value !== null && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : '';
      });
      const sort = params.get('tcg_sort');
      this.sort.value = ['title', 'price-asc', 'price-desc'].includes(sort) ? sort : 'title';
      this.page = Math.max(1, parseInt(params.get('tcg_page'), 10) || 1);
    }

    writeUrl() {
      if (location.protocol === 'about:') return;
      const url = new URL(location.href);
      ['set', 'stock', 'live', 'min', 'max', 'sort', 'page'].forEach((name) => url.searchParams.delete(`tcg_${name}`));
      url.searchParams.delete('page');
      for (const [name, value] of new FormData(this.form)) {
        if (value !== '') url.searchParams.append(`tcg_${name}`, value);
      }
      if (this.sort.value !== 'title') url.searchParams.set('tcg_sort', this.sort.value);
      if (this.page > 1) url.searchParams.set('tcg_page', this.page);
      history.replaceState(null, '', url);
    }

    bind() {
      this.form.addEventListener('submit', (event) => event.preventDefault());
      this.form.addEventListener('change', () => { this.page = 1; this.apply(true); });
      this.form.addEventListener('input', (event) => {
        if (event.target.type === 'number') { this.page = 1; this.apply(true); }
      });
      this.form.addEventListener('reset', () => {
        // Apply after the native reset default action has cleared the controls.
        setTimeout(() => { this.page = 1; this.apply(true); }, 0);
      });
      this.sort.addEventListener('change', () => { this.page = 1; this.apply(true); });
      this.querySelectorAll('[data-set-chip]').forEach((button) => button.addEventListener('click', () => {
        const input = [...this.form.querySelectorAll('[name="set"]')].find((field) => field.value === button.dataset.setChip);
        if (input) { input.checked = !input.checked; this.page = 1; this.apply(true); }
      }));
      this.querySelector('[data-prev]').addEventListener('click', () => this.changePage(-1));
      this.querySelector('[data-next]').addEventListener('click', () => this.changePage(1));
      this.querySelectorAll('[data-open-filters]').forEach((button) => button.addEventListener('click', () => {
        this.filterOpener = button;
        if (!matchMedia('(max-width: 989px)').matches) {
          this.querySelector('.tcg-category__filters').scrollIntoView({ block: 'start', behavior: 'smooth' });
          this.form.querySelector('input')?.focus({ preventScroll: true });
          return;
        }
        this.classList.add('filters-open');
        this.querySelector('[data-close-filters]').focus();
        this.querySelector('[aria-controls]').setAttribute('aria-expanded', 'true');
      }));
      this.querySelector('[data-close-filters]').addEventListener('click', () => this.closeFilters());
      this.addEventListener('keydown', (event) => {
        if (!this.classList.contains('filters-open')) return;
        if (event.key === 'Escape') this.closeFilters();
        if (event.key === 'Tab') {
          const controls = [...this.querySelector('.tcg-category__filters').querySelectorAll('button,input,select,a[href]')];
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      window.addEventListener('popstate', () => { this.readUrl(); this.apply(); });
    }

    closeFilters() {
      this.classList.remove('filters-open');
      this.querySelector('[aria-controls]').setAttribute('aria-expanded', 'false');
      this.filterOpener?.focus();
    }

    changePage(delta) {
      this.page += delta;
      this.apply(true);
      this.querySelector('[data-category-toolbar]').scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    apply(updateUrl = false) {
      const values = new FormData(this.form);
      const sets = values.getAll('set'), stocks = values.getAll('stock');
      const min = values.get('min') === '' ? 0 : Number(values.get('min')) * 100;
      const max = values.get('max') === '' ? Infinity : Number(values.get('max')) * 100;
      const live = values.has('live');
      const filtered = this.items.filter((item) =>
        (!sets.length || sets.some((set) => item.tags.includes(set))) &&
        (!stocks.length || stocks.includes(String(item.available))) &&
        item.price >= min && item.price <= max && (!live || (item.live && item.available))
      );
      filtered.sort((a, b) => {
        const stock = Number(b.available) - Number(a.available);
        if (stock) return stock;
        let price = 0;
        if (this.sort.value === 'price-asc') price = a.price - b.price;
        if (this.sort.value === 'price-desc') price = b.price - a.price;
        return price || this.collator.compare(a.title, b.title);
      });
      const pages = Math.max(1, Math.ceil(filtered.length / this.pageSize));
      this.page = Math.min(Math.max(1, this.page), pages);
      const start = (this.page - 1) * this.pageSize;
      const visible = filtered.slice(start, start + this.pageSize);
      this.pool.forEach((node) => { node.hidden = true; });
      this.grid.querySelector('[data-sold-heading]')?.remove();
      let soldHeading = false;
      visible.forEach((item) => {
        if (!item.available && !soldHeading) {
          const heading = document.createElement('h2');
          heading.className = 'tcg-category__sold-heading';
          heading.dataset.soldHeading = '';
          heading.textContent = `${this.dataset.stockLabel} (${filtered.filter((entry) => !entry.available).length})`;
          this.grid.append(heading);
          soldHeading = true;
        }
        item.node.hidden = false;
        this.grid.append(item.node);
      });
      const count = this.dataset.countLabel.replace('{start}', filtered.length ? start + 1 : 0).replace('{end}', start + visible.length).replace('{count}', filtered.length);
      this.querySelector('[data-result-count]').textContent = count;
      this.querySelector('[data-category-empty]').hidden = filtered.length !== 0;
      this.querySelector('[data-category-pagination]').hidden = pages === 1;
      this.querySelector('[data-page-count]').textContent = this.dataset.pageLabel.replace('{page}', this.page).replace('{pages}', pages);
      this.querySelector('[data-prev]').disabled = this.page === 1;
      this.querySelector('[data-next]').disabled = this.page === pages;
      this.querySelectorAll('[data-set-chip]').forEach((button) => button.setAttribute('aria-pressed', String(sets.includes(button.dataset.setChip))));
      const active = sets.length + stocks.length + Number(live) + Number(values.get('min') !== '') + Number(values.get('max') !== '');
      this.querySelector('[data-active-count]').textContent = active ? `(${active})` : '';
      if (updateUrl) this.writeUrl();
    }
  }
  customElements.define('tcg-category', TcgCategory);
})();



